<template>
  <component
    :is="tradeInLabelComp"
    v-if="label"
    class="body-2-bold whitespace-nowrap"
    @click="countryCode === MarketCountryCode.US ? openDaModal() : undefined"
  >
    {{ label }}
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { MarketCountryCode } from '@backmarket/http-api'
import type { GetOfferV1Response } from '@backmarket/http-api/src/api-specs-buyback/customer/getOfferV1'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevLink } from '@ds/components/Link'
import { openModal } from '@ds/components/ModalBase'

import { useUrlParams } from '~/scopes/product/composables/useUrlParams'
import { MODAL_NAMES } from '~/scopes/product/constants'

import {
  COUNTRIES_WITH_TRADE_IN_PRICE_LABEL,
  COUNTRIES_WITH_VAT_PRICE_LABEL,
} from '../../../Price.constants'
import translations from '../PriceLabel.translations'

const props = defineProps<{
  buybackOffer: GetOfferV1Response | null
}>()

const i18n = useI18n()
const { mobilePlan } = useUrlParams()
const { trackClick } = useTracking()

const {
  market: { countryCode },
} = useMarketplace()

const isSwapActive = computed(() => {
  return Boolean(props.buybackOffer)
})

const tradeInLabelComp = computed(() => {
  return countryCode === MarketCountryCode.US ? RevLink : 'div'
})

const label = computed(() => {
  if (mobilePlan.value && isSwapActive.value) {
    return i18n(translations.withTradeInAndMobilePlan)
  }

  if (mobilePlan.value) {
    return i18n(translations.withMobilePlan)
  }

  if (isSwapActive.value) {
    return i18n(translations.withTradeIn)
  }

  if (COUNTRIES_WITH_TRADE_IN_PRICE_LABEL.includes(countryCode)) {
    return i18n(translations.beforeTradeIn)
  }

  if (COUNTRIES_WITH_VAT_PRICE_LABEL.includes(countryCode)) {
    return i18n(translations.vatIncluded)
  }

  return null
})

function openDaModal() {
  openModal(MODAL_NAMES.TRADE_IN)
  trackClick({
    zone: 'trade-in pill',
    name: 'trade-in info',
  })
}
</script>
